<div class="content-layout right-sidebar-fullheight-basic-inner-scroll">
  <div class="main p-0">
    <div class="list-wrapper">
      <!-- Header -->
      <header class="header">
        <!-- Title -->
        <section class="header__title">
          <h1 class="m-0">Sheet Templates</h1>
          <div class="font-medium">
            <ng-container *ngIf="sheetTemplatesCount > 0">
              {{ sheetTemplatesCount }}
              {{
                sheetTemplatesCount
                  | i18nPlural
                    : {
                        '=0': 'No templates',
                        '=1': 'template',
                        other: 'templates'
                      }
              }}
            </ng-container>
          </div>
        </section>

        <!-- Main actions -->
        <div class="header__main-actions">
          <button mat-flat-button [color]="'primary'" (click)="openAddTemplateDialog()">
            <mat-icon [svgIcon]="'add'"></mat-icon>
            New Template
          </button>
        </div>
      </header>

      <!-- Sheet Templates list -->
      <div class="templates-list">
        <ng-container *ngIf="dataSource && sheetTemplatesCount > 0; else noTemplates">
          <!-- Table -->
          <table
            mat-table
            matSort
            [matSortActive]="'name'"
            [matSortDisableClear]="true"
            [matSortDirection]="'asc'"
            [dataSource]="dataSource"
            [trackBy]="trackByFn"
          >
            <ng-container *ngIf="sheetTemplatesCount > 0; else noTemplates">
              <!-- Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let sheetTemplate">
                  <div class="name-content">
                    <span class="name"
                      ><a [routerLink]="['./' + sheetTemplate.id]">{{ sheetTemplate.name }}</a></span
                    >
                  </div>
                </td>
              </ng-container>

              <!-- Created -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Created</th>
                <td mat-cell *matCellDef="let sheetTemplate">
                  {{ sheetTemplate.created_at | date: 'MMM dd, y' }}
                </td>
              </ng-container>

              <!-- Last Updated -->
              <ng-container matColumnDef="updated_at">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Updated</th>
                <td mat-cell *matCellDef="let sheetTemplate">
                  {{ sheetTemplate.updated_at | date: 'MMM dd, y' }}
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let sheetTemplate">
                  <div class="flex">
                    <button mat-icon-button class="delete-task" (click)="deleteSheetTemplate(sheetTemplate)">
                      <mat-icon [svgIcon]="'delete'"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="sheetTemplatesTableColumns; sticky: true"></tr>

              <tr class="template-row" mat-row *matRowDef="let sheetTemplate; columns: sheetTemplatesTableColumns"></tr>
            </ng-container>
          </table>
        </ng-container>

        <ng-template #noTemplates>
          <div class="no-templates">There are no templates!</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
